import React, {useState, useRef, useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import './BurgerMenu.css';
import {Heading} from "../Heading";

const CHIPS = [
    {id: 'services', tKey: 'main.headerChips.1', tCount: '6'},
    {id: 'products', tKey: 'main.headerChips.2', tCount: '1'},
    {id: 'projects', tKey: 'main.headerChips.3', tCount: '2'},
    {id: 'about', tKey: 'main.headerChips.4', tCount: '2'},
    {id: 'bitrix24', tKey: 'main.headerChips.5', tCount: '1'},
    {id: 'FAQ', tKey: 'main.headerChips.6', tCount: '25'},
];

export default function MainBurgerMenu() {
    const [open, setOpen] = useState(false);
    const {t} = useTranslation();
    const navigate = useNavigate();
    const ref = useRef<HTMLDivElement>(null);

    // Закрываем дропдаун при клике вне
    useEffect(() => {
        const onClickOutside = (e: MouseEvent) => {
            if (ref.current && !ref.current.contains(e.target as Node)) {
                setOpen(false);
            }
        };
        document.addEventListener('mousedown', onClickOutside);
        return () => document.removeEventListener('mousedown', onClickOutside);
    }, []);

    const onClikeTabs = (e: React.MouseEvent<HTMLAnchorElement>, id: string) => {
        e.preventDefault(); // ⬅️ опционально, чтобы избежать перезагрузки
        navigate(`/main/${id}`);
    };

    return (
        <div className="relative" ref={ref}>
            <div
                className="w-8 h-8 flex items-center justify-center cursor-pointer"
                onClick={() => setOpen(v => !v)}
            >
                <img
                    src={open ? "/images/burgerMenuClose.svg" : "/images/headerBurgerIcon.svg"}
                    alt={open ? "Close menu" : "Open menu"}
                />
            </div>
            {open && (
                <div className="tui-dropdown absolute right-0 mt-2  overflow-visible bg-white p-2">
                    {CHIPS.map(({id, tKey, tCount}) => (
                            <a
                                key={id}
                                href={`#${id}`}
                                className="tui-dropdown-item"
                                onClick={(e) => onClikeTabs(e, id)}
                            >
                                <div className={"flex flex-row justify-between w-full"}>
                                    <Heading className="label">
                                        {t(tKey)}
                                    </Heading>
                                    <div className="gap-2 flex flex-row">
                                        <Heading
                                            size="desktop_body_s"
                                            className="rounded-full bg-[#79818C1F] w-6 h-6 text-center">
                                            {t(tCount)}
                                        </Heading>
                                        <img
                                            src={"/images/dropdownArrowLeft.svg"}
                                            alt="leftArrow"
                                            className="m-auto"/>
                                    </div>
                                </div>
                            </a>
                    ))}

                    <div className='w-full h-px bg-[#E0E0E0] my-2'/>
                    <button
                        className="w-full h-[32px] rounded-[30px] bg-[#0C88F0] flex items-center justify-center px-2 md:hidden"
                    >
                        <img
                            src={"/images/callUsIcon.svg"}
                            alt="call usIcon"
                        />
                        <Heading
                            size={"desktop_body_s"}
                            className={"text-[#FFFFFF] w-auto flex-row"}>
                            <a href="tel:+74955427541">
                                +7(495)542-75-41
                            </a>
                        </Heading>
                    </button>
                </div>
            )}
        </div>
    );
}
